import './new.note.list.scss';

import { Divider, Stack } from '@mui/material';

import { NewNoteListDetail } from './new.note.list.detail';
import { NotesListDetailData } from '@converge/graphql';

export interface INoteListProps {
  notes: NotesListDetailData[];
}
export const NewNoteList = ({ notes }: INoteListProps) => {
  return (
    <Stack>
      <Divider className="divider-style new-note-list-divider" />
      <div className="main-notes-container">
        {notes.map((note, index) => (
          <NewNoteListDetail key={index} note={note} />
        ))}
      </div>
    </Stack>
  );
};
